import { render, staticRenderFns } from "./WorkerDeposit.vue?vue&type=template&id=4e4bc146&scoped=true"
import script from "./WorkerDeposit.vue?vue&type=script&lang=js"
export * from "./WorkerDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4bc146",
  null
  
)

export default component.exports